// extracted by mini-css-extract-plugin
module.exports = {"section":"FbyHn","typeform":"_4jKTm"};